import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import RouterConfig from './routers';
import ViewUI from 'view-design';
import store from "./store/index";
import 'view-design/dist/styles/iview.css'
import "core-js/stable";
import "regenerator-runtime/runtime";


Vue.use(ViewUI);
Vue.use(VueRouter);

Vue.config.productionTip = false;

const router = new VueRouter(RouterConfig);

new Vue({
    render: h => h(App),
    router: router,
    store,
}).$mount('#app');

